import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

export const VISIBILITY_VALUE = {
  HIDDEN: 'Hidden',
  UNHIDDEN: 'Unhidden',
};

/**
 * Numeric visibility values, matching \App\Enums\VisibilityEnum.
 */
export const VISIBILITY_NUMERIC_VALUE = {
  HIDDEN: 0,
  UNHIDDEN: 1,
};

export const VISIBILITY_TO_READABLE = {
  [VISIBILITY_VALUE.HIDDEN]: globalTranslate('visibility.hidden'),
  [VISIBILITY_VALUE.UNHIDDEN]: globalTranslate('visibility.unhidden'),
};

export class Visibility {
  constructor(dto) {
    this.name = dto.name;
    this.value = dto.value;
  }

  /**
   * Map to readable
   * @param {Visibility} visibility Visibility.
   * @returns {string}
   */
  static toReadable(visibility) {
    const readableVisibility = VISIBILITY_TO_READABLE[visibility.name];
    return readableVisibility ?? visibility.name;
  }
}
